var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyProfit = function SvgMoneyProfit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.038,
    height: 84,
    viewBox: "0 0 70.038 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5502",
    "data-name": "Group 5502",
    transform: "translate(13072 4601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Money_profit",
    "data-name": "Money profit",
    transform: "translate(-13075.989 -4601.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4643",
    "data-name": "Path 4643",
    d: "M51.256,45.829V19.247c4.742,0,6.3.42,6.877-1.12s.525-1.05-17.954-17.674a1.75,1.75,0,0,0-2.345,0L20.335,16.2a1.75,1.75,0,0,0,1.172,3.045h5.25V38.5H8.383a4.375,4.375,0,0,0-4.375,4.375c0,5.932-.192,6.44.892,7.875-1.12,1.487-.892,2.2-.892,7.875A4.392,4.392,0,0,0,4.9,61.246a4.392,4.392,0,0,0-.892,2.625c0,5.932-.192,6.44.892,7.875-1.12,1.487-.892,2.2-.892,7.875a4.375,4.375,0,0,0,4.375,4.375H38.132a4.375,4.375,0,0,0,4.375-4.41,19.249,19.249,0,1,0,8.75-33.756ZM28.507,15.748H26.075L39.007,4.111,51.939,15.748H49.506a1.75,1.75,0,0,0-1.75,1.75V46.826a19.424,19.424,0,0,0-6.072,3.92c1.085-1.522.822-2.45.822-7.787A4.375,4.375,0,0,0,38.132,38.5H30.257v-21A1.75,1.75,0,0,0,28.507,15.748Zm-21,53.373c0-5.25-.28-6.125.875-6.125H35.594a18.392,18.392,0,0,0,.665,7C6.546,70,7.508,70.363,7.508,69.12Zm0-10.5c0-5.25-.28-6.125.875-6.125,31.394,0,30.624-.385,30.624.875,0,.875-1.557,1.907-2.747,6.125C6.546,59.5,7.508,59.863,7.508,58.621Zm0-15.749c0-1.26-1.225-.875,30.624-.875,1.155,0,.875.91.875,6.125,0,1.26,1.225.875-30.624.875C7.228,49,7.508,48.086,7.508,42.871ZM38.132,80.495c-31.394,0-30.624.385-30.624-.875,0-5.25-.28-6.125.875-6.125H37.642a17.394,17.394,0,0,0,1.365,2.275C39.007,79.515,39.234,80.495,38.132,80.495Zm16.624,0A15.749,15.749,0,1,1,70.505,64.745,15.749,15.749,0,0,1,54.756,80.495Z",
    transform: "translate(0)",
    fill: "#171926"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1_05_Realbewertung",
    "data-name": "1,05 \\u20AC Realbewertung",
    transform: "translate(-13013 -4528)",
    fill: "#171926",
    fontSize: 22,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600,
    letterSpacing: "0.014em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.886,
    y: 0
  }, "\u20AC")))));
};
export default SvgMoneyProfit;